import React, { Component } from "react";
import PropTypes from "prop-types";
import createHistory from "history/createBrowserHistory";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import ReactGA from "react-ga";
import { withStyles } from "@material-ui/core/styles";
// import AppBar from "material-ui/AppBar";
// import Toolbar from "material-ui/Toolbar";
import Home from "./NewRoute/components/Home";
import NotFound from "./components/NotFound";
import NavBar from "./components/NavBar";
import Ambassadors from "./Ambassadors/components/Ambassadors";
import firebase from "./components/firebase.js";
import Login from "./components/Login";
import About from "./NewRoute/components/About";
import Privacy from "./NewRoute/components/Privacy";
import Welcome from "./components/Welcome";
import CookieConsent from "react-cookie-consent";

ReactGA.initialize("UA-116965267-1", {
  debug: !process.env.NODE_ENV || process.env.NODE_ENV === "development"
});

const history = createHistory();
history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

const styles = theme => ({
  content: {
    display: "block",
    position: "absolute",
    height: "auto",
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    paddingBottom: "56px"
  },
  navBar: {
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 10
  },
  feedback: {
    width: "100%"
  }
});

const PrivateRoute = ({ component: Component, isSignedIn, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isSignedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  location: PropTypes.string
};

const FirstRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("version") !== null ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/welkom",
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
FirstRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.string
};

class App extends Component {
  state = {
    isSignedIn: false,
    userProfile: null
  };

  componentDidMount() {
    // Updating the `isSignedIn` and `userProfile` local state attributes when the Firebase Auth
    // state changes.
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      this.setState({ isSignedIn: !!user, userProfile: user });
    });
  }

  componentWillUnmount() {
    // Un-registers the auth state observer.
    this.unregisterAuthObserver();
  }

  logout = () => {
    firebase
      .auth()
      .signOut()
      .then(
        function() {
          // console.log("Signed Out");
        },
        function(error) {
          // console.error("Sign Out Error", error);
        }
      );
  };

  render() {
    const { classes } = this.props;
    return (
      <Router history={history}>
        <div className={classes.root}>
          <div className={classes.content}>
            <Switch>
              <FirstRoute exact path="/" component={Home} />
              <Route exact path="/eigenroute" component={Home} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/ambassadeurs" component={Ambassadors} />
              <Route exact path="/over" component={About} />
              <Route exact path="/privacyverklaring" component={Privacy} />
              <Route exact path="/404" component={NotFound} />
              <Route exact path="/welkom" component={Welcome} />
              <Redirect to="/404" />
            </Switch>
          </div>
          <CookieConsent
            location="bottom"
            buttonText="Ik aanvaard dit"
            style={{ background: "#2B373B" }}
            buttonStyle={{
              color: "white",
              backgroundColor: "#3F51B5",
              fontSize: "13px"
            }}
            expires={150}
          >
            Deze website maakt gebruik van cookies om je gebruikerservaring te
            verbeteren.
          </CookieConsent>
          <div className={classes.navBar}>
            <NavBar />
          </div>
        </div>
      </Router>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js